// Keep in sync with FREE_SIGNUP_CREDITS in /app/backend/server.py
export const FREE_SIGNUP_CREDITS = 5;
